import { render, staticRenderFns } from "./NavigationItem.vue?vue&type=template&id=7c7f5cbb&scoped=true&"
import script from "./NavigationItem.vue?vue&type=script&lang=js&"
export * from "./NavigationItem.vue?vue&type=script&lang=js&"
import style0 from "./NavigationItem.vue?vue&type=style&index=0&id=7c7f5cbb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7f5cbb",
  null
  
)

export default component.exports